export const ru = {
    'are-you-sure-to-apply-many-items':
        'Изменятся {count} объектов. Применить рекомендацию?',
    'are-you-sure-to-apply-one-item':
        'Изменится {count} объект. Применить рекомендацию?',
    'are-you-sure-to-apply-some-items':
        'Изменятся {count} объекта. Применить рекомендацию?',
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.',
    'no-rights': 'Нет доступа для просмотра рекомендаций',
    'try-later':
        'При применении рекомендации возникла ошибка. Попробуйте ещё раз.'
};
